import "./style.css";
import { useParams, useNavigate } from "react-router-dom";
import { AcceptProvider, GetProviderDetails, RejectProvider } from "../../../../api/endpoints/ProvidersRR";
import { useGet, useUpdate } from "../../../../api/hooks";
import Details from "./Components/RequestData";
import NoExist from "@/components/NoExist";
import Skeleton from "./Components/skeleton";
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { CRRender } from "@/components/crRender";
import { PROVIDER_REQUEST_STATUS } from "@/data/status";

export const ProvidersRRDetails = () => {


    const { onUpdate: onAccept } = useUpdate(AcceptProvider)
    const { onUpdate: onReject } = useUpdate(RejectProvider)

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams()

    const { result: requestDetails, isPending } = useGet({ endPoint: GetProviderDetails, depArr: [], allowFetch: !!id, params: [id] })


    return (
        <>
            <div className="provider-rr-header">
                <button className="back-button" onClick={() => navigate(-1)}>
                    <Icon icon="mdi:arrow-right" />
                    {t("back-to-requests")}
                </button>
                <div className="provider-rr-actions">
                    <CRRender isRender={requestDetails?.statusId != PROVIDER_REQUEST_STATUS.Accepted}>

                        <button className="approve-button" onClick={() => onAccept(id)}>
                            <Icon icon="mdi:check" />
                            {t("accept")}
                        </button>
                    </CRRender>
                    <CRRender isRender={requestDetails?.statusId != PROVIDER_REQUEST_STATUS.Rejected}>
                        <button className="reject-button" onClick={() => onReject(id)}>
                            <Icon icon="mdi:close" />
                            {t("reject")}
                        </button>
                    </CRRender>
                </div>
            </div>

            <Skeleton isRender={isPending} />
            <Details requestDetails={requestDetails} />

            <NoExist isExist={!requestDetails?.providerName && !isPending} />

        </>
    );
}


export default ProvidersRRDetails